///<reference path="../api.d.ts" />

module agencyRegistration.controller {
    
    export class SearchController {
        searchService: agencyRegistration.service.SearchService;
        agentFactory : agencyRegistration.factory.agentFactory;
        agency: API.Client.AgencyModel;
        state: angular.ui.IStateService;
        loader : any = {};
        eventMessages: Array<string> = ["registeredAgency", "serviceError"];
        
        /*@ngInject*/
        constructor(
            $scope: ng.IScope, 
            $rootScope : ng.IRootScopeService, 
            $state: angular.ui.IStateService, 
            SearchService:agencyRegistration.service.SearchService, 
            agentFactory: agencyRegistration.factory.agentFactory
        ) {
            this.state = $state;
            this.searchService = SearchService;
            this.agentFactory = agentFactory;
            this.agency = this.agentFactory.getAgency();
            this.agency.cnpj = $state.params["cnpj"];
            
            // Search CNPJ there's any CNPJ in URL
            this.agency.cnpj && this.searchCNPJ();
        };
        
        redirectToLogin(): void {
          parent.window.location.href = "/Login";   
        };

        searchCNPJ(): void {
            this.loader.show = true;
            this.setEventMessages(this.eventMessages, false);
            
            this.searchService.searchAgency(this.agency.cnpj).then(agency => {
                if (agency) {
                    this.setEventMessages(["registeredAgency"], true); 
                    this.state.go("search", this.agency);
                }
                else 
                    this.state.go("search.create", this.agency);
            }).catch(() => {
                this.setEventMessages(["serviceError"], true); 
                //this.state.go("search", this.agency);
            }).finally(() => {
                this.loader.show = false;
            });
        };
        
        private setEventMessages(messages: Array<string>, state: boolean): void {
            messages.forEach(message => this[message] = state);
        };
    }
}

angular.module('agencyRegistrationApp').controller('SearchController', agencyRegistration.controller.SearchController);